module.exports = __webpack_public_path__ + "img/智慧工地.c29d5c19.png";